import { RichText } from "components/RichTextWidget";
import {
  Container,
  Heading3,
  Icon,
  OrderedList,
  PageLink,
  Paragraph,
} from "shared/components";

import styles from "./Content061.module.scss";

export const Content061 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.caption ?? "";
  const list = payload?.list ?? [];
  const buttonText = payload?.button?.buttonText ?? "";
  const slug = payload?.button?.page?.slug ?? "";

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.blocks}>
          <div className={styles.top}>
            <Heading3 as="h3" className={styles.title}>
              {title}
            </Heading3>
            <RichText
              value={description}
              className={styles.description}
              color="dark"
            />
          </div>
          <div className={styles.content}>
            <PageLink slug={slug} className={styles.link}>
              <span className={styles.arrow}>
                <Icon className={styles.icon} name="arrow_right" />
              </span>
              <Paragraph
                color="brand"
                appearance="bigger"
                className={styles["button-text"]}
              >
                {buttonText}
              </Paragraph>
            </PageLink>
            <OrderedList
              items={list}
              className={styles.list}
              appearance="bigger"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content061;
